var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "email-preview-modal",
        title: "Email Preview",
        "hide-footer": true,
        "no-fade": "",
        size: "lg"
      },
      on: {
        change: _vm.onModalChange,
        hide: _vm.onModalChange,
        show: _vm.onModalChange
      },
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", {
          staticClass: "email-content",
          domProps: { innerHTML: _vm._s(_vm.emailHtml) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66a9ad04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a9ad04","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/EmailRecord/EmailPreviewModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66a9ad04","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/EmailRecord/EmailPreviewModal.vue
// module chunks = 0